import { createRouter, RouterProvider } from '@tanstack/react-router'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient, useAbilityStore } from '@/shared'
import { routeTree } from '@/app/routeTree.gen'
import { NotFoundPage } from '@/pages/not-found/ui/NotFoundPage'
import { Provider } from '@/app/providers/chakra-provider'
import { MaintenancePage } from '@/pages/maintenance/ui/MaintenancePage'
import { isMaintenanceMode } from '@/env'
import { useAuthStore } from './shared/store/authStore'

const router = createRouter({
  routeTree,
  context: {
    queryClient: undefined!,
    user: undefined!,
    authStore: undefined!,
    abilityStore: undefined!,
  },
  scrollRestoration: true,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  defaultNotFoundComponent: NotFoundPage,
})
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

export function RootApp() {
  if (JSON.stringify(isMaintenanceMode) === 'true') {
    return (
      <Provider>
        <MaintenancePage />
      </Provider>
    )
  }
  const user = useAuthStore((state) => state.user)
  const authStore = useAuthStore()
  const abilityStore = useAbilityStore()
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <RouterProvider
          context={{ queryClient, user, authStore, abilityStore }}
          router={router}
        />
      </QueryClientProvider>
    </>
  )
}

const root = createRoot(document.getElementById('root')!)

root.render(<RootApp />)
